import {useEffect} from 'react';

function SkiTest2023CSS() {
  useEffect(() => {
    import('../../styles/wordpress/styles.css');
  }, []);
  return null;
}

export default SkiTest2023CSS;
